export const CHECKOUT_BASIC = 'https://www.recursoclosethegap.shop'
export const CHECKOUT_PREMIUM = 'https://www.recursoclosethegap.shop'

export const HERO_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/rrCH5ZrugQ2pUV8VEXETdv/Mock_Up_-_Cocina_Lista_-_Sin_fondo.png'

export const stats = [
  { value: '+800', label: 'familias cocinando' },
  { value: '6', label: 'Tomos listos' },
  { value: '6', label: 'Bonos incluidos' },
  { value: '4.9/5', label: '⭐' },
  { value: '2 hs', label: 'semana resuelta' },
]

export const miniTestimonials = [
  {
    initials: 'VR',
    quote:
      'Tardaba 1 hora por día pensando qué cocinar. Ahora lo resuelvo el domingo y el resto de la semana no pienso más en eso.',
    author: 'Valeria R., Córdoba · 2 hijos',
  },
  {
    initials: 'LM',
    quote:
      'Bajé $100.000 por mes en delivery. Solo con eso ya se pagó el pack como diez veces. Encima como mucho mejor.',
    author: 'Lucas M., Buenos Aires · Soltero',
  },
  {
    initials: 'SC',
    quote:
      'Las viandas del Tomo 4 me cambiaron la vida. Llevo tupper todos los días y ya no caigo en comida del trabajo.',
    author: 'Sofía C., Rosario · Trabaja en oficina',
  },
]

export const pains = [
  'Domingo mirando la heladera sin saber por dónde empezar',
  'Miércoles sin comida lista, pidiendo delivery que se come el presupuesto de toda la semana',
  'Llegás a casa cansado y no hay nada listo — el teléfono con la app ya está en tu mano',
  'Recetas de internet con ingredientes que no conseguís o que cuestan el doble en Argentina',
  'Comés siempre lo mismo porque no sabés cómo variar sin recomenzar todo desde cero',
  'Tirás comida porque no supiste organizarla — plata que se va a la basura literalmente',
  'Fin de semana ocupado cocinando, limpiando, comprando — sin tiempo libre real',
]

export const tomoTags = [
  'El Método de las 2 Horas',
  'Otoño / Invierno',
  'Primavera / Verano',
  'Especial Viandas',
  'Desayunos y Snacks',
  'Fiestas y Reuniones',
]

export const tomos = [
  {
    emoji: '📗',
    title: 'TOMO 1 — El Método de las 2 Horas',
    subtitle: 'El sistema base completo',
    desc: 'La Regla del 3x3, el Domingo de Preparación paso a paso y las recetas base del sistema: pollo, carne, huevo, arroz, lentejas y papa. Lista de compras + checklist + tabla de conservación incluidos.',
  },
  {
    emoji: '📘',
    title: 'TOMO 2 — Otoño / Invierno',
    subtitle: 'El sistema para la estación fría',
    desc: 'Zapallo, remolacha, acelga. Guisos express, sopas y cremas. Modo presupuesto mínimo. Menú semanal invernal y lista de compras estacional argentina incluidos.',
  },
  {
    emoji: '📙',
    title: 'TOMO 3 — Primavera / Verano',
    subtitle: 'El sistema para los meses de calor',
    desc: 'Tomate, choclo, morrón. Bowls fríos, wraps y aderezos frescos. El sistema sin horno ni microondas para los días imposibles. Menú semanal y lista estival incluidos.',
  },
  {
    emoji: '📕',
    title: 'TOMO 4 — El Especial Viandas',
    subtitle: 'El tupper que no se abre más',
    desc: '20 viandas distintas para todo el mes. Armado en 3 minutos la noche anterior. Resistencia sin cadena de frío. Checklist nocturno incluido.',
  },
  {
    emoji: '📓',
    title: 'TOMO 5 — Desayunos y Snacks',
    subtitle: 'Todo lo que pasa fuera del almuerzo y la cena',
    desc: 'Desayuno en batch, muffins, granola sin azúcar y licuados proteicos sin suplementos. Opciones express de 2 minutos para los días imposibles. Planificador semanal incluido.',
  },
  {
    emoji: '📔',
    title: 'TOMO 6 — Fiestas y Reuniones',
    subtitle: 'El sistema para la vida social argentina',
    desc: 'Asados, picadas saludables, empanadas al horno, postres sin azúcar refinada. La filosofía 80/20 aplicada a las comidas fuera de casa. Lista de compras incluida.',
  },
]

export const tomoIncludes = [
  'Menú semanal listo para usar',
  'Lista de compras estacional',
  'Checklist del Domingo de Preparación',
  'Tabla de conservación heladera y freezer',
  'Adaptaciones para 1 a 4 personas',
  'Ingredientes 100% accesibles en Argentina',
]

export const bonos = [
  {
    num: '01',
    title: 'BONO 1 — Reset Heladera en 30 Min',
    subtitle: 'Todo visible, todo a mano',
    desc: 'Organizá tu heladera para que los módulos tengan lugar, sean visibles y se usen antes de vencerse.',
    price: '$8.000',
  },
  {
    num: '02',
    title: 'BONO 2 — Calculadora de Porciones Argentina',
    subtitle: 'Cocinás exactamente lo que necesitás',
    desc: 'Cuánto cocinar exactamente para 1, 2, 3, 4 y 5 personas. Sin desperdiciar ni quedarte corto.',
    price: '$9.000',
  },
  {
    num: '03',
    title: 'BONO 3 — Mapa de Sustituciones Inteligentes',
    subtitle: 'Misma función, distinto ingrediente',
    desc: 'Reemplazos para cada elemento del sistema. El sistema no para nunca, aunque falte algo en la góndola.',
    price: '$9.000',
  },
  {
    num: '04',
    title: 'BONO 4 — SOS No Cociné',
    subtitle: 'Cerrá la app de delivery',
    desc: 'Comidas reales en 10 minutos con lo que ya tenés en casa. Para las noches en las que el sistema se cayó.',
    price: '$8.000',
  },
  {
    num: '05',
    title: 'BONO 5 — Etiquetas, Freezer y Comando Semanal',
    subtitle: 'Cero desperdicio planificado',
    desc: 'El sistema de etiquetado, zonas del freezer e inventario semanal. Sabés exactamente qué tenés, dónde está y cuándo usarlo.',
    price: '$9.000',
  },
  {
    num: '06',
    title: 'BONO 6 — Guía Anti-Excusas Cocina Lista',
    subtitle: 'Volvé al sistema siempre',
    desc: 'Las 10 excusas más comunes con respuesta directa y una acción de 5 minutos para cada una.',
    price: '$9.000',
  },
]

export const comparison = [
  {
    sit: 'Post batch cooking del domingo',
    sin: '1 hora de limpieza acumulada',
    con: '15 min integrados mientras cocinás',
  },
  {
    sit: 'Horno con grasa acumulada',
    sin: 'Fuerza + químicos fuertes',
    con: 'Bicarbonato toda la noche. Trapo y listo.',
  },
  {
    sit: 'Tuppers con olor a salsa',
    sin: 'No salen o los tirás',
    con: 'Agua + bicarbonato + agitar. Listo.',
  },
  {
    sit: 'Presupuesto en limpieza',
    sin: '$9.000–$15.000 ARS por mes',
    con: '$2.600–$4.000 ARS con 4 insumos base',
  },
  {
    sit: 'Sábado de limpieza general',
    sin: '3–4 horas agotadoras',
    con: '40 minutos de mantenimiento express',
  },
  {
    sit: 'La cocina el lunes a la mañana',
    sin: 'Da ansiedad abrirla',
    con: 'Bacha vacía, mesadas limpias, energía',
  },
]

export const launchPrices = [
  { name: 'Mega Pack Cocina Lista', normal: '$52.000', launch: '$19.990 ARS' },
  { name: 'Mega Pack + Sistema Total', normal: '$71.000', launch: '$27.990 ARS' },
]

export const testimonials = [
  {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Mendoza',
    product: 'Sistema Total',
    quote:
      'El Bono 4 de SOS me salvó tres veces la primera semana. Cerré la app de delivery y me hice un bowl en 8 minutos con lo que tenía.',
  },
  {
    initials: 'PM',
    name: 'Pablo M.',
    location: 'Buenos Aires',
    product: 'Sistema Total',
    quote:
      'Compré el Sistema Total y el método de limpieza solo ya valió la inversión. Paso de 3 horas de sábado a 40 minutos.',
  },
  {
    initials: 'MF',
    name: 'Mariana F.',
    location: 'Rosario',
    product: 'Mega Pack',
    quote:
      'Tengo dos chicos y marido. El Tomo de Invierno fue un antes y un después. Guisos express que gustan a todos y se hacen solos.',
  },
  {
    initials: 'RV',
    name: 'Rodrigo V.',
    location: 'Tucumán',
    product: 'Sistema Total',
    quote:
      'El sistema de etiquetas del Bono 5 parece una tontería hasta que lo usás. Nunca más abrí el freezer sin saber qué había adentro.',
  },
]

export const faqs = [
  {
    question: '¿Sirve si vivo solo/a o si somos familia numerosa?',
    answer:
      'Sí. La Calculadora del Bono 2 adapta todas las cantidades para 1, 2, 3, 4 y 5 personas. El sistema funciona igual independientemente del tamaño del hogar.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      '100% digital en PDF. Después de la compra recibís un correo con acceso a todos los archivos. Los descargás una vez y los tenés para siempre, sin suscripciones ni pagos adicionales.',
  },
  {
    question: '¿Los ingredientes son difíciles de conseguir?',
    answer:
      'No. Todo es de súper, feria o verdulería local argentina. Pollo, arroz, lentejas, papa, huevo, zanahoria, zapallo. Nada que no hayas visto en tu supermercado de siempre.',
  },
  {
    question: '¿Necesito saber cocinar?',
    answer:
      'No. El sistema usa solo 5 técnicas: hervir, saltear, hornear, mezclar y guardar. Si podés hervir agua, podés hacer el sistema completo.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días completos. Si no es lo que esperabas, devolvemos el 100% sin preguntas. Nuestra tasa de devoluciones es menor al 1%.',
  },
  {
    question: '¿Qué diferencia tiene el Sistema Total del Mega Pack base?',
    answer:
      'El Mega Pack base incluye los 6 tomos y los 6 bonos. El Sistema Total agrega el Método Cocina Impecable: limpieza y organización en 15 minutos diarios para que el entorno donde cocinás también esté en orden.',
  },
]

export const costs = [
  {
    sin: '1 hora diaria pensando qué cocinar × 365 días = 365 horas de tu vida por año',
    real: '2 horas el domingo. Semana resuelta. Lunes a viernes sin pensar en comida.',
  },
  {
    sin: 'Delivery 3 veces por semana = $100.000–$150.000 ARS mensuales',
    real: 'Costo real por porción con el sistema: $2.000–$3.000 ARS',
  },
  {
    sin: 'Recetas con ingredientes que no conseguís o cuestan el doble',
    real: 'Ingredientes de súper o feria. Todo disponible. Todo accesible.',
  },
  {
    sin: 'Comida tirada porque no supiste organizarla',
    real: 'Sistema de etiquetas y freezer. Cero desperdicio planificado.',
  },
  {
    sin: 'Lunes sin vianda = delivery urgente o comida del trabajo',
    real: '20 viandas distintas. Tupper listo en 3 minutos la noche anterior.',
  },
  {
    sin: 'El próximo domingo, el mismo ciclo, desde cero',
    real: 'Un sistema que mejora cada semana y funciona para siempre.',
  },
]
